export default __webpack_public_path__ + "static/media/logoFooter.48082dcc.svg";